import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import IpConfirmationForum from './IpConfirmationForum';
import ComfirmationSuccess from './ComfirmationSuccess';

function IpConfirmation({ classes, setIpConfirmation, ip, email }) {
  const dispatch = useDispatch();
  const [forum, setForum] = useState(true);


  if(forum == true){
      return (
          <IpConfirmationForum classes={classes} setIpConfirmation = {setIpConfirmation} setForum = {setForum} ip = {ip} email = {email}  />
      )
  }
  else
  {
      return (
          <ComfirmationSuccess classes={classes} setIpConfirmation = {setIpConfirmation} />
      )
  }
}

export default IpConfirmation;
